import { setLanguage } from "@klantondersteuning-zvw/shared";
import * as React from "react";
import { IKlachtenFormulierZvwPageProps } from "../interfaces/klachten-formulier-zvw-page";

const KlachtenFormulierZvwPageWrapper = React.lazy(() => import("./KlachtenFormulierZvwPage"));

export function KlachtenFormulierZvwPage(props: IKlachtenFormulierZvwPageProps) {
  React.useEffect(() => {
    setLanguage(props.language);
  }, []);

  return (
    <div>
      <React.Suspense
        fallback={
          <div className="pilet-loader" role="status">
            Loading...
          </div>
        }
      >
        <section>
          <KlachtenFormulierZvwPageWrapper
            apiUrl={props.apiUrl}
            pageBaseUrl={props.pageBaseUrl}
            language={props.language}
          />
        </section>
      </React.Suspense>
    </div>
  );
}
